module.exports = __webpack_public_path__ + "static/img/bg.0291dd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4/bg.jpg
// module id = mos4
// module chunks = 7